import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class ProducerInfoService {
    static getContactSummaries(authHeader = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('profileinfoProducer'),
            'getProducersContactSummaries',
            [],
            authHeader
        );
    }
}
